import { Component, ChangeDetectionStrategy, input, inject, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SafeHtmlPipe } from '../../shared/safe-html-pipe';
import { NAV, CURRENT_USER, iconFor, NavCluster } from '../../common/nav-data';
import { AuthService } from '../../shared/auth.service';

/**
 * Sidebar for the STATIC reference shell. Same clustered taxonomy as the live
 * `Sidemenu`, but every link points at `/static/<key>` so navigating stays
 * inside the frozen reference set. A footer link returns to the live app.
 */
@Component({
  selector: 'app-static-sidemenu',
  imports: [RouterLink, SafeHtmlPipe],
  templateUrl: './static-sidemenu.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticSidemenu {
  readonly activeKey = input<string>('');

  // `hidden` NAV items (Profile/Notifications) have no `static-pages/<key>`
  // counterpart to link to — see NavItem's doc on `hidden`.
  protected readonly nav: NavCluster[] = NAV.map((cluster) => ({
    cluster: cluster.cluster,
    items: cluster.items.filter((item) => !item.hidden),
  })).filter((cluster) => cluster.items.length > 0);

  private readonly authService = inject(AuthService);
  protected readonly user = computed(() => this.authService.currentUser() ?? CURRENT_USER);
  protected readonly iconFor = iconFor;
}
